// assets/product-custom-property.js
import { Component } from '@theme/component';

/**
 * @typedef {object} ProductCustomPropertyRefs
 * @property {HTMLInputElement | HTMLTextAreaElement} textInput - The text input.
 * @property {HTMLElement} characterCount - The character count element.
 */

/**
 * A custom element that manages product custom properties
 * @extends Component<ProductCustomPropertyRefs>
 */
class ProductCustomProperty extends Component {
  handleInput() {
    this.#updateCharacterCount();
  }

  #updateCharacterCount() {
    const { characterCount, textInput } = this.refs;
    const currentLength = textInput.value.length;
    const maxLength = textInput.maxLength;

    const template = characterCount.getAttribute('data-template');
    if (!template) return;

    const updatedText = template.replace('[current]', currentLength.toString()).replace('[max]', maxLength.toString());

    characterCount.textContent = updatedText;
  }
}

customElements.define('product-custom-property-component', ProductCustomProperty);
// Accelerated checkout guard — only for Personalized Theme Paint Kit (product 10315085512956)
(function () {
  const GUARDED_PRODUCT_ID = '10315085512956';
  const NAME_PROPERTY_KEY = 'Name to Personalize';
  function getProductFormComponent() {
    return document.querySelector(`product-form-component[data-product-id="${GUARDED_PRODUCT_ID}"]`);
  }
  function getNameInput(formComponent) {
    if (!formComponent) return null;
    return formComponent.querySelector(`input[name="properties[${NAME_PROPERTY_KEY}]"], textarea[name="properties[${NAME_PROPERTY_KEY}]"]`);
  }
  function getAcceleratedButtons(formComponent) {
    if (!formComponent) return [];
    const root = formComponent.closest('.buy-buttons-block') || document.body;
    return Array.from(root.querySelectorAll('[name="checkout"], .shopify-payment-button__button, [data-testid="Checkout-button"]'));
  }
  function updateAcceleratedButtons(nameInput, buttons) {
    if (!nameInput) return;
    const isValid = nameInput.value.trim().length > 0 && nameInput.validity.valid;
    buttons.forEach((btn) => {
      btn.disabled = !isValid;
      btn.setAttribute('aria-disabled', String(!isValid));
      btn.style.opacity = isValid ? '' : '0.4';
      btn.style.pointerEvents = isValid ? '' : 'none';
    });
  }
  function initGuard() {
    const formComponent = getProductFormComponent();
    if (!formComponent) return;
    const nameInput = getNameInput(formComponent);
    if (!nameInput) return;
    const root = formComponent.closest('.buy-buttons-block') || document.body;
    function refresh() {
      const buttons = getAcceleratedButtons(formComponent);
      updateAcceleratedButtons(nameInput, buttons);
    }
    nameInput.addEventListener('input', refresh);
    nameInput.addEventListener('change', refresh);
    const observer = new MutationObserver(refresh);
    observer.observe(root, { childList: true, subtree: true });
    refresh();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGuard);
  } else {
    initGuard();
  }
})();
